"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class AnalyticsService {
    /**
     * @param id
     * @returns AnalyticsData team data for user by team id with sport, plan, and team types
     * @throws ApiError
     */
    static user(id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/analytics',
            query: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                403: `Unauthorized`,
            },
        });
    }
}
exports.AnalyticsService = AnalyticsService;
